var _jsxFileName = "/media/data/Sandbox/soapbox-defake/app/soapbox/components/ui/phone-input/country-code-dropdown.tsx";
import React from 'react';
import { COUNTRY_CODES } from 'soapbox/utils/phone';

/** Dropdown menu to select a country code. */
const CountryCodeDropdown = _ref => {
  let {
    countryCode,
    onChange
  } = _ref;
  return /*#__PURE__*/React.createElement("select", {
    value: countryCode,
    className: "h-full py-0 pl-3 pr-7 text-base bg-transparent border-transparent focus:outline-none focus:ring-primary-500 dark:text-white sm:text-sm rounded-md",
    onChange: event => onChange(event.target.value),
    __self: this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 13,
      columnNumber: 5
    }
  }, COUNTRY_CODES.map(code => /*#__PURE__*/React.createElement("option", {
    value: code,
    key: code,
    __self: this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 19,
      columnNumber: 9
    }
  }, "+", code)));
};

export default CountryCodeDropdown;